import { EditableArea } from '@magnolia/react-editor';

export interface CarouselPageProps {
    main: any;
}

const CarouselPage = (props: CarouselPageProps) => {
    const {main} = props;

    return (
        <>
            {main && <EditableArea content={main} />}
        </>
    );
};

export default CarouselPage;
